import { render, staticRenderFns } from "./VerticalNavMenuItem.vue?vue&type=template&id=93db5fc4"
import script from "./VerticalNavMenuItem.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuItem.vue?vue&type=script&lang=js"
import style0 from "./VerticalNavMenuItem.vue?vue&type=style&index=0&id=93db5fc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports